var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 698,
    viewBox: "0 0 1440 698",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_463)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 698,
    fill: "#230E44"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1_463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1005.51 -40.9152L-634.731 1275.75L690.122 1612.61L1644.51 633.915L1273.73 -682.755L-51.1198 -1019.61L-1005.51 -40.9152Z",
    fill: "#340E44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-786.711 15.1938L-477.364 1113.72L629.005 1395.58L1425.71 577.806L1116.37 -520.717L9.99743 -802.58L-786.711 15.1938Z",
    fill: "#420E46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-588.855 65.1871L-334.67 967.824L573.529 1198.58L1227.86 527.813L973.672 -374.824L65.473 -605.58L-588.855 65.1871Z",
    fill: "#581945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-402.581 112.436L-200.424 830.316L521.501 1013.82L1041.58 480.563L839.427 -237.316L117.501 -420.824L-402.581 112.436Z",
    fill: "#762844"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-239.475 154.196L-83.0774 709.58L475.742 851.327L878.477 438.803L722.08 -116.58L163.261 -258.327L-239.475 154.196Z",
    fill: "#963844"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-119.05 185.152L3.49793 620.332L441.892 731.123L758.051 407.848L635.503 -27.3323L196.796 -139.237L-119.05 185.152Z",
    fill: "#BD4843"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.5992 211.278L78.1138 544.062L413.371 629.841L654.602 381.722L560.889 48.9373L225.631 -36.8413L-15.5992 211.278Z",
    fill: "#DF5944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1452 231.429L132.038 479.626L383.046 543.482L563.848 358.027L493.955 109.83L242.947 45.9741L62.1452 231.429Z",
    fill: "#FF6E46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.463 250.78L188.924 429.972L370.119 476.248L500.539 342.22L450.078 163.028L268.884 116.752L138.463 250.78Z",
    fill: "#FF8850"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.345 265.787L233.568 383.765L352.88 415.033L438.343 326.099L405.121 208.122L286.122 177.966L200.345 265.787Z",
    fill: "#FF9C58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.418 278.677L268.164 348.796L339.404 367.175L390.584 314.322L370.839 244.204L299.599 225.825L248.418 278.677Z",
    fill: "#FFB662"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.629 286.424L291.285 324.266L330.001 333.785L356.947 305.776L346.291 267.934L308.688 258.102L280.629 286.424Z",
    fill: "#FFD16D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.332 285.267C306.993 286.207 305.394 289.06 306.335 292.399L306.648 293.512C304.422 294.139 302.823 296.992 303.764 300.331C304.077 301.444 304.39 302.557 305.817 303.356C303.904 305.096 303.105 306.523 303.732 308.748C304.359 310.974 307.211 312.574 309.437 311.947L311.663 311.32L321.679 308.5L318.858 298.483L316.351 289.579C315.411 286.24 312.558 284.64 310.332 285.267Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.128 297.337L313.466 296.397L314.72 300.849L315.66 304.188L307.87 306.382",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.128 297.337L313.466 296.397L314.72 300.849L315.66 304.188L307.87 306.382",
    stroke: "#FFD16D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.642 299.877C310.871 299.531 311.587 298.254 311.241 297.024C310.894 295.795 309.617 295.079 308.388 295.425C307.159 295.771 306.443 297.048 306.789 298.278C307.135 299.507 308.412 300.223 309.642 299.877Z",
    fill: "white",
    stroke: "#FFD16D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.496 308.608C309.726 308.262 310.442 306.985 310.095 305.755C309.749 304.526 308.472 303.81 307.243 304.156C306.013 304.502 305.298 305.779 305.644 307.009C305.99 308.238 307.267 308.954 308.496 308.608Z",
    fill: "white",
    stroke: "#FFD16D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.467 296.397L311.9 290.832",
    stroke: "#FFD16D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.462 282.133C324.8 281.193 327.653 282.792 328.593 286.131L328.907 287.244C331.133 286.618 333.985 288.217 334.926 291.556C335.239 292.669 335.552 293.782 334.753 295.208C337.292 295.694 338.718 296.494 339.345 298.72C339.972 300.946 338.373 303.799 336.147 304.425L333.922 305.052L323.905 307.873L321.084 297.856L318.577 288.952C317.637 285.613 319.236 282.76 321.462 282.133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.935 292.323L324.596 293.263L326.163 298.828L326.79 301.054L334.58 298.86",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.935 292.323L324.596 293.263L326.163 298.828L326.79 301.054L334.58 298.86",
    stroke: "#FFD16D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.674 294.236C330.903 293.89 331.619 292.612 331.273 291.383C330.927 290.154 329.649 289.438 328.42 289.784C327.191 290.13 326.475 291.407 326.821 292.637C327.167 293.866 328.445 294.582 329.674 294.236Z",
    fill: "white",
    stroke: "#FFD16D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.094 301.4C335.323 301.054 336.039 299.777 335.693 298.547C335.346 297.318 334.069 296.602 332.84 296.948C331.611 297.294 330.895 298.571 331.241 299.801C331.587 301.03 332.864 301.746 334.094 301.4Z",
    fill: "white",
    stroke: "#FFD16D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.595 293.263L323.028 287.698",
    stroke: "#FFD16D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.212 291.945C313.441 291.599 314.157 290.322 313.811 289.092C313.465 287.863 312.188 287.147 310.959 287.493C309.729 287.839 309.013 289.117 309.359 290.346C309.706 291.575 310.983 292.291 312.212 291.945Z",
    fill: "white",
    stroke: "#FFD16D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.342 288.811C324.571 288.465 325.287 287.188 324.941 285.958C324.595 284.729 323.318 284.013 322.088 284.359C320.859 284.705 320.143 285.983 320.489 287.212C320.836 288.441 322.113 289.157 323.342 288.811Z",
    fill: "white",
    stroke: "#FFD16D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    width: 811,
    height: 689,
    transform: "translate(627 4)",
    fill: "url(#paint0_linear_1_463)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_463",
    x1: 610.5,
    y1: 20.0463,
    x2: 21.7127,
    y2: 199.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_463"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 698,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1_463"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2367.89,
    height: 2734.6,
    fill: "white",
    transform: "translate(-1190.74 -698.694) rotate(-15.7274)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.56fbb7c2b45c61231d29febd3e55cdad.svg";
export { ForwardRef as ReactComponent };